<div class="flex">
  <div class="pygWidthLeft hidden sm:block"></div>
  <section
    id="instore"
    class="w-10/12 sm:w-full mx-auto flex flex-wrap lg:justify-between pt-5 sm:pt-14 pb-14 lg:pb-20"
  >
    <div class="mx-auto lg:w-5/12 lg:mx-0 lg:text-left lg:my-auto lg:pr-3">
      <h1 class="pt-2 pb-4">{{ "main_page.instore.title" | translate }}</h1>
      <p class="sm:pb-6">{{ "main_page.instore.subtitle" | translate }}</p>
      <div class="hidden lg:flex">
        <app-get-info langRouterLink="solutions" class="mr-5">
        </app-get-info>
        <app-get-demo class="block xl:inline-block mb-3"></app-get-demo>
      </div>
    </div>
    <div class="w-11/12 mt-11 lg:w-7/12 lg:my-auto hidden sm:block">
      <img
        class="h-auto p-0 w-full"
        src="assets/img/MainPage/in-store.svg"
        alt="Transforming physical reality into actionable data"
      />
    </div>

    <div class="flex flex-wrap w-full lg:hidden">
      <app-get-info
        class="block w-full max-w-md mt-7"
        langRouterLink="solutions"
      ></app-get-info>
      <app-get-demo class="block w-full max-w-md mt-4"></app-get-demo>
    </div>
  </section>
  <div class="pygWidthRight hidden sm:block"></div>
</div>
